import React from 'react';
import VideoPlayer from '../components/VideoPlayer';
import SocialShare from '../components/SocialShare';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCalendar,FiCpu,FiGlobe,FiVideo,FiRadio,FiTrendingUp}=FiIcons;

const HomePage=({currentTime})=> {
  const services=[
    {icon: FiVideo,title: 'Live Broadcasting',description: 'Professional 24/7 streaming services with HD quality',href: 'https://drlmspace.agencyhandy.com/catalog'},
    {icon: FiRadio,title: 'Content Production',description: 'High-quality video production and post-production',href: 'https://drlmspace.agencyhandy.com/catalog'},
    {icon: FiGlobe,title: 'Digital Marketing',description: 'Strategic promotion and audience engagement',href: 'https://drlmspace.agencyhandy.com/catalog'},
    {icon: FiCpu,title: 'Technology Solutions',description: 'Cutting-edge broadcast technology integration',href: 'https://drlmspace.agencyhandy.com/catalog'},
    {icon: FiTrendingUp,title: 'Analytics & Insights',description: 'Comprehensive viewership and performance metrics',href: 'https://drlmspace.agencyhandy.com/catalog'},
    {icon: FiCalendar,title: 'Event Broadcasting',description: 'Live event coverage and special programming',href: 'https://drlmspace.agencyhandy.com/catalog'}
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section with Video Player */}
      <section className="px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
        <div className="max-w-7xl mx-auto">
          <motion.div initial={{opacity: 0,y: 50}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8}} className="text-center mb-8" >
            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-4">
              Ligon Road Innovations <span className="text-blue-400">LLC</span>
            </h2>
            <p className="text-gray-300 text-lg lg:text-xl max-w-2xl mx-auto">
              Cutting-edge content,innovative programming,and breakthrough technology streaming live from Ligon Road Innovations LLC Television
            </p>
          </motion.div>

          {/* Video Player */}
          <VideoPlayer />

          {/* Station Info */}
          <div className="mt-12 max-w-2xl mx-auto">
            <SocialShare />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="max-w-7xl mx-auto">
          <motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} className="text-center mb-12" >
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">Our Services</h2>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto">
              Comprehensive broadcasting and media solutions to elevate your content
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service,index)=> (
              <motion.a key={index} href={service.href} target="_blank" rel="noopener noreferrer" initial={{opacity: 0,y: 50}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: index * 0.1}} className="bg-black/40 backdrop-blur-lg rounded-xl border border-blue-500/30 p-6 hover:border-blue-400/50 hover:bg-blue-600/10 transition-all duration-300 group" >
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <SafeIcon icon={service.icon} className="text-white text-xl" />
                  </div>
                  <h3 className="text-xl font-bold text-white group-hover:text-blue-400 transition-colors">
                    {service.title}
                  </h3>
                </div>
                <p className="text-gray-300 leading-relaxed">{service.description}</p>
                <div className="mt-4 flex items-center text-blue-400 text-sm font-medium group-hover:text-blue-300 transition-colors">
                  <span>View catalog</span>
                  <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{opacity: 0,y: 30}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.4}} className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 lg:p-12 text-center" >
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Ready to Transform Your Broadcasting?
            </h2>
            <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
              Schedule a demo with our team and discover how Ligon Road Innovations can help grow your communication and event planning needs.
            </p>
            <motion.a href="https://cal.lionelmaten.com/" target="_blank" rel="noopener noreferrer" whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} className="inline-flex items-center space-x-3 bg-white text-blue-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-50 transition-colors duration-300 shadow-lg" >
              <SafeIcon icon={FiCalendar} className="text-xl" />
              <span>Schedule a Demo</span>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;